import { MapCluster, Scan } from '@/interfaces';
import { MapsState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const mutations = {
  setMapClusters(state: MapsState, payload: MapCluster[]) {
    state.clusters = payload;
  },
  clearMapScans(state: MapsState) {
    state.scans = [];
  },
  setMapScans(state: MapsState, payload: { data: Scan[]; append: boolean }) {
    state.scans = payload.append
      ? state.scans.concat(payload.data)
      : payload.data;
  },
};

const { commit } = getStoreAccessors<MapsState, State>('');

export const commitSetMapClusters = commit(mutations.setMapClusters);
export const commitClearMapScans = commit(mutations.clearMapScans);
export const commitSetMapScans = commit(mutations.setMapScans);
